export const CONSOLE_LOG_KEY = '[Manage Images Modal]'
export const GALLERY_PAGE_SIZE = 9
export const GALLERY_IMAGE_DIMENSION = '165x225'
export const GALLERY_SEARCH_DEBOUNCE_TIME = 750 // in miliseconds

export const PRODUCT_IMAGES_LIMIT = 100

export const UPLOAD_PRODUCT_MAX_AMOUNT = 1
export const UPLOAD_COLOR_MAX_AMOUNT = 1
export const UPLOAD_GALLERY_MAX_AMOUNT = 9
export const UPLOAD_MAX_SIZE = 10 * 1000 * 1000 // 10MB in bytes
export const UPLOAD_ACCEPTED_FORMAT = 'image/png, image/jpeg'
